import { apiUrl } from 'config/app'
require('es6-promise').polyfill();
require('isomorphic-fetch');
import { startSocialAuth, successSocialAuth, failedSocialAuth, successAuth, failedAuth } from 'actions/user'


export const fetchUserAPI = (response, dispatch) => {
  let headers = new Headers();
  headers.append('Content-Type', 'application/json');

  return fetch(`${apiUrl}/short/v1/user`, {
    method: 'POST',
    body: JSON.stringify(response),
    mode: 'cors',
    headers: headers
  })
      .then(response => response.json())
      .then(
          (result) => dispatch(successAuth(result, response)),
          (error) => dispatch(failedAuth(error))
      );
};

const fetchUserFacebook = (dispatch) => {
  // eslint-disable-next-line
  FB.api('/me?fields=id,email,name,picture', function (response) {
    dispatch(successSocialAuth(response));
    fetchUserAPI(response, dispatch)
  });
}


export const authUserSocial = () => {
  return dispatch => {
    dispatch(startSocialAuth());

// eslint-disable-next-line
    FB.login(function (response) {
      if (response.authResponse) {
        fetchUserFacebook(dispatch)
      } else {
        dispatch(failedSocialAuth())
      }
    }, { scope: 'email,user_likes' });


  };
};






// WEBPACK FOOTER //
// ./src/async/login.js